import { Grid } from "@mui/material";
import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { useFormikContext } from "formik";
import { useMessage } from "hooks/intl";
import { useStyles } from "./styles";

export function Int({ fieldName }: { fieldName: string }) {
  const classes = useStyles();
  const { message } = useMessage();
  const { setFieldValue } = useFormikContext();

  return (
    <>
      <Grid item xs={6}>
        <SelectInput
          className={classes.input}
          data-test-id="condition-operator"
          width="100%"
          items={[
            { id: "is_equal", label: message({ id: "is_equal" }) },
            {
              id: "is_not_equal",
              label: message({ id: "is_not_equal" }),
            },
            { id: "is_greater", label: message({ id: "is_greater_than" }) },
            {
              id: "is_greater_or_equal",
              label: message({ id: "is_greater_or_equal" }),
            },
            { id: "is_less", label: message({ id: "is_less_than" }) },
            {
              id: "is_less_or_equal",
              label: message({ id: "is_less_or_equal" }),
            },
          ]}
          label={<RequiredFieldLabel text={message({ id: "condition" })} />}
          name={`${fieldName}.operator`}
          onChange={() => setFieldValue(`${fieldName}.data`, null)}
        />
      </Grid>
      <Grid item xs={12}>
        <NumberFormatInput
          // The component is called Int (integer), but previously it allowed passing decimal numbers.
          // To avoid bc breaks - still allow decimal numbers to be passed.
          allowDecimals
          label={
            <RequiredFieldLabel
              text={message({
                id: "value",
              })}
            />
          }
          name={`${fieldName}.data`}
          data-test-id="condition-value"
        />
      </Grid>
    </>
  );
}
